module.exports = __webpack_public_path__ + "img/no.409d0b6c.svg";